import { KeycloakTokenParsed } from "keycloak-js";

/* iat - issuedAtTime - timestamp of token creation
   exp - expirationTime - timestamp of token expiration
   exp is always bigger than iat */

export const getSessionLength = (token?: KeycloakTokenParsed): number => {
  if (token) {
    const { exp, iat } = token;

    if (exp && iat) {
      return Number(exp - iat);
    }
  }

  return 0;
};


export const getCounterTime = (expireSeconds: number) => {
  if (expireSeconds < 0) return "00:00";

  const time = {
    seconds: Math.floor((((expireSeconds % 31536000) % 86400) % 3600) % 60),
    minutes: Math.floor(expireSeconds / 60),
  };
  const { seconds, minutes } = time;

  return `${padToTwo(minutes)}:${padToTwo(seconds)}`;
};

export const padToTwo = (number: number) =>
  number <= 9 ? `0${number}` : `${number}`;

export const getSecondsToExpiration = (sessionTimeout: number) => {
  const currentTime = new Date().getTime();
  return Math.round((sessionTimeout - currentTime) / 1000);
}